import * as React from 'react';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';

import StoresQuery from '../../components/Query/Stores';
import StoreDetail from './StoreDetail';
import { Title } from '../../components/Layout/components';

interface IStoresTableState {
}

interface IStoresTableProps extends RouteComponentProps {
  domain: string;
  storeId?: string;
}

class StoresTable extends React.Component<IStoresTableProps, IStoresTableState> {

  constructor(props: IStoresTableProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <StoresQuery domain={this.props.domain}>
            {({ stores, deleteStore, createStore, updateStore }: any) => {
              return this.renderData(
                stores,
                updateStore,
                createStore,
                deleteStore,
                stores.refetch
              );
            }}
          </StoresQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    storesQuery: any,
    updateStore: Function,
    createStore: Function,
    deleteStore: Function,
    refetch: Function
  ) {
    if (!storesQuery.loading) {

      if (this.props && this.props.storeId) {
        return (
          <StoreDetail
            languages={storesQuery.languages}
            store={storesQuery.stores.find((s: GQL.IStore) => s.id === this.props.storeId) || undefined}
            onSave={a => this.upsert(a, updateStore, createStore, refetch)}
            onCancel={() => this.cancel()}
          />);
      }

      return (
        <div>
          <Title>Stores</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new store</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={storesQuery.stores || []}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Name" dataIndex="name" key="name" />
            <Table.Column title="Priority" dataIndex="priority" key="priority" width={100} align="center" />
            <Table.Column
              width={180}
              title="Actions"
              dataIndex="actions"
              key="actions"
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteStore, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading stores ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, store: GQL.IStore, deleteStore: Function, refetch: Function) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(store.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(store, deleteStore, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(store: GQL.IStore, deleteStore: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete store ${store.name}?`,
      content: (
        <span>
          Are you sure you want to delete store <strong>{store.name}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteStore({
          variables: {
            id: store.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    store: GQL.IStore,
    updateStore: Function,
    createStore: Function,
    refetch: Function
  ) {
    if (store !== undefined) {
      const variables = {
        id: store.id,
        store: {
          name: store.name,
          slug: store.slug,
          title: store.title,
          subtitle: store.subtitle,
          description: store.description,
          address: store.address,
          phone: store.phone,
          email: store.email,
          openingTimes: store.openingTimes,
          storePhoto: store.storePhoto,
          storeBackground: store.storeBackground,
          storeVirtualView: store.storeVirtualView,
          storePhotogallery: store.storePhotogallery,
          priority: store.priority
        }
      };

      if (store.id) {

        return updateStore({ variables })
          // .then(() => this.setCurrentStore(null))
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Store "${variables.store.name}" has been updated.`
            })
          );
      }

      (variables.store as any).domain = this.props.domain;

      createStore({ variables })
        // .then(() => this.setCurrentStore(null))
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Store "${variables.store.name}" has been created.`
          })
        );
    }
  }

  private getLink(storeId: string | null) {
    return `/${this.props.domain}/application/${storeId ? `store/${storeId}` : 'stores'}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(StoresTable);



// WEBPACK FOOTER //
// ./src/scenes/Stores/StoresTable.tsx